/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Link_BtnInputs */



/**
* | output |
* | --- |
* | "Link VEKN" |
*
* @param {Vekn_Link_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_link_btn = /** @type {((inputs?: Vekn_Link_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Link_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lier VEKN")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vincular VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Vincular VEKN")
	if (locale === "it") return /** @type {LocalizedString} */ ("Collega VEKN")
	return /** @type {LocalizedString} */ ("Link VEKN")
});